import * as O from 'fp-ts/Option';
import { pipe } from 'fp-ts/function';

export const formatFirstAppearanceDate = (t: (key: string) => string, first_appearance_date?: O.Option<string>) =>
  pipe(
    first_appearance_date || O.none,
    O.getOrElse(() => t('SETTINGS.PRODUCT_FAMILIES.NONE_FIRST_APPERENCE_DATE')),
  );
